var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBankerror(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.765 10C32.325 10 10 32.43 10 60C10 87.57 32.43 110 60 110C87.57 110 110 87.57 110 60C110 32.43 87.465 10 59.765 10ZM60 100C37.945 100 20 82.055 20 60C20 37.945 37.835 20 59.765 20C81.955 20 100 37.945 100 60C100 82.055 82.055 100 60 100Z",
    fill: "#D0342C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55 35H65V70H55V35ZM55 75H65V85H55V75Z",
    fill: "#D0342C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankerror);
export default __webpack_public_path__ + "static/media/bankerror.9c3a784fedd1c9c21d4921ac89799fc9.svg";
export { ForwardRef as ReactComponent };